import {
  Users, Zap, Snowflake, Footprints, EyeOff, Eye, Link2, ArrowUpDown, Flag,
  Swords, Rows3, Layers, MoveHorizontal, Target, CircleDot, Dices, Disc,
  Grid3x3, Repeat, Disc3, Wind, Sparkles,
} from "lucide-react";

const MAP = {
  users: Users, zap: Zap, snowflake: Snowflake, footprints: Footprints,
  "eye-off": EyeOff, eye: Eye, link: Link2, "arrow-up-down": ArrowUpDown,
  flag: Flag, swords: Swords, rows: Rows3, layers: Layers,
  "move-horizontal": MoveHorizontal, target: Target, "circle-dot": CircleDot,
  dices: Dices, disc: Disc, grid: Grid3x3, repeat: Repeat, "disc-3": Disc3, wind: Wind,
};

export const getGameIcon = (name) => MAP[name] || Sparkles;
